import { useNavigate } from 'react-router-dom';

import { UseAlert } from '../../../presentation/hook/AlertHook';

import { PublicRoutes } from '../../../main/constant/RouteConstant';

import { ForgotPasswordUseCase } from '../../../data/useCase/ForgotPasswordUseCase';

import ForgotPasswordPage from '../../../presentation/page/forgotPassword/ForgotPasswordPage';
import { EndpointsConstant } from '../../../main/constant/EndpointConstant';

/**
 * AddPatientPageDomain - regra de negocio de Paciente
 * @constructor
 */
export const ForgotPasswordPageDomain: React.FC = () => {
  /**
   * Alertas
   */
  const { showAlert } = UseAlert();

  /**
   * navegacao da url
   */
  const navigate = useNavigate();

  /**
   * endpoint
   */
  const ENDPOINT_FORGOT_PASSWORD = EndpointsConstant.forgotPassword;

  /**
   * sendPassword
   * @param params
   */
  const sendPassword = async (params: { login: string }) => {
    await new ForgotPasswordUseCase(`${ENDPOINT_FORGOT_PASSWORD}`)
      .Post({
        data: {
          login: params.login,
        },
      })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          showAlert({
            show: true,
            content: 'Operação realizada com sucesso',
            color: 'success',
            time: 2000,
          });
        } else {
          showAlert({
            show: true,
            content: 'Ops!!! Algo deu errado tente novamente mais tarde...',
            color: 'danger',
            time: 2000,
          });
        }

        if (response.statusCode === 200) {
          navigate(PublicRoutes.LOGIN);
        }
      })
      .catch((error) => {
        showAlert({
          show: true,
          content: 'Ops!!! Algo deu errado tente novamente mais tarde...',
          color: 'danger',
          time: 2000,
        });
        console.error('ERRO: ', error);
      });
  };

  return (
    <>
      <ForgotPasswordPage sendPassword={sendPassword} />
    </>
  );
};
